var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-container',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"mx-2 my-1 mx-md-6 mt-md-2"},[_c('vue-word-cloud',{style:(_vm.computedStyle),attrs:{"font-size-ratio":3,"words":_vm.computedWords,"color":_vm.getWordColor,"font-family":"Roboto"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var text = ref.text;
var weight = ref.weight;
var word = ref.word;
return [_c('div',{style:({
            cursor: 'pointer',
          }),attrs:{"title":weight},on:{"click":function($event){return _vm.onWordClick(word)}}},[_vm._v(" "+_vm._s(text)+" ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }